import { vec2Len } from "geom/vec2";
import type { Vec3 } from "geom/vec3";

export function getId() {
  return Math.floor(Math.random() * Number.MAX_VALUE);
}

const DEFAULT_SLOPE_RUN = 12;

function deriveDownwardSlopVectorRise(downVec: Vec3) {
  const [x, y, z] = downVec;

  if (x === 0 && y === 0 && z === 0) {
    throw Error("cannot find slope with 0 length vec3");
  }

  const run = vec2Len(x, y);
  const rise = Math.abs(z);
  const multiplier = DEFAULT_SLOPE_RUN / run;
  return Math.round(rise * multiplier * 8) / 8;
}

export function downwardSlopeVectorToRoofSlopeFormat(downVec: Vec3): string {
  return `${deriveDownwardSlopVectorRise(downVec)}:${DEFAULT_SLOPE_RUN}`;
}

export function downwardSlopeVectorToElevSlopeFormat(downVec: Vec3): number[] {
  return [deriveDownwardSlopVectorRise(downVec), DEFAULT_SLOPE_RUN];
}

/**
 * @deprecated This is temporary. If we'd need this in more cases, it would be better to use a more robust library.
 * We use it for annotations while they're still being generated as SVG (they should be SheetGeometry instead)
 */
export function sanitizeXmlTextContent(text: string): string {
  return text
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#x27;");
}
